import i18n from "i18next";
import { AavoTextField } from "src/components/common/inputFields/AavoTextField.tsx";
import type { CustomerOrderDataGridExtraFilterComponentsProps } from "src/tenantCustomizations/TenantCustomizations.ts";

export const LapellandCustomerOrderFilterComponents = ({
	refreshData,
}: CustomerOrderDataGridExtraFilterComponentsProps) => (
	<AavoTextField
		label={i18n.t("manufacturer_or_registration_number")}
		onSubmit={(input) =>
			refreshData({
				tenantSpecificFilters: { registrationOrSerialNumber: input ?? "" },
			})
		}
	/>
);
